import { Link, useNavigate } from "react-router-dom"
// components
import { AppDrawer } from "./Drawer"
import { Button } from "@components/Button"
// hooks
import useAuth from "@hooks/useAuth"
// helpers
import { NAV_LINK } from "./helper"
// assets
import Logo from "@assets/Common/logo-black.png"

export const Navbar = () => {
    // hooks
    const { handleLogoutSession } = useAuth()
    const handleSignOut = () => {
        handleLogoutSession()
    }

    const navigate = useNavigate()

    // handlers
    const handleLogoRedirection = () => {
        navigate("/chooseview")
    }

    return (
        <div className="w-full">
            <div
                className="hidden sm:flex items-center justify-between  w-full 
      px-5 lg:px-10 xl:px-14 2xl:px-20 
      py-5"
            >
                <button
                    className="flex items-center sm:w-28 md:w-36"
                    onClick={handleLogoRedirection}
                >
                    <img src={Logo} height="auto" width={132} alt="logo" />
                </button>
                <div className="flex items-center sm:gap-4 xs:gap-4 md:gap-8">
                    {NAV_LINK.map((link) => (
                        <Link
                            to={link.path}
                            key={link.key}
                            className={`text-[var(--text-nav)] text-xs sm:text-[12px] md:text-sm 3xl:text-base font-semibold`}
                        >
                            {link.title}
                        </Link>
                    ))}
                    <Button
                        variant="secondary"
                        onClick={handleSignOut}
                        size="sm"
                    >
                        Sign Out
                    </Button>
                </div>
            </div>
            <AppDrawer />
        </div>
    )
}
